import WorkScheduleHelpers from '../../services/helpers/WorkScheduleHelpers';
import classnames from 'classnames';
import useMenu from '../../hooks/menu/useMenu';
import useAppMethods from '../../hooks/utility/useAppMethods';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import { OpeningHoursInterface } from '../../services/exports/Interfaces';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
}

export default function MenuList({ className }: Props) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Menu:MenuList' });

  const { company } = useSelector((state: StoreInterface) => state.initialData);

  const { formatScheduleUnit } = useAppMethods();
  const { menus, selectedMenu, setSelectedMenu } = useMenu();

  return menus.count() === 1 ? null : (
    <div>
      <h5>{t('header')}</h5>
      <div className={classnames('flex mt-md overflow-x-auto scrollbar-hide', className)}>
        {menus.map((item, index) => (
          <div
            key={`${selectedMenu?.id}-company-menu-${item?.id}-${index}`}
            className={classnames('mr-lg px-sm py-2xs group cursor-pointer text-center rounded-lg', {
              'bg-brand-primary text-white dark:text-black': item?.id === selectedMenu?.id,
              border: item?.id !== selectedMenu?.id,
            })}
            onClick={() => setSelectedMenu(item)}
          >
            <h6 className="uppercase text-sm">{item?.name}</h6>
            <p className="mt-2xs text-xs">
              {WorkScheduleHelpers.formatSchedule(
                item?.schedule ?? company?.work_schedule,
                (item: OpeningHoursInterface) => `${formatScheduleUnit(item.open)} - ${formatScheduleUnit(item.close)}`,
                (item: OpeningHoursInterface) =>
                  `${formatScheduleUnit(item.open, { day: true, time: true })} - ${formatScheduleUnit(item.close, { day: true, time: true })}`,
              )}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
